import React from 'react';
import ReactMarkdown from 'react-markdown';

const PatentWordGenerator = ({ every }) => {
  const handleDownload = () => {
    const header = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' 
            xmlns:w='urn:schemas-microsoft-com:office:word' 
            xmlns='http://www.w3.org/TR/REC-html40'>
      <head><meta charset='utf-8'><title>Patent Document</title></head><body>`;
    const footer = `</body></html>`;

    const content = document.getElementById('word-content').innerHTML;
    const sourceHTML = header + content + footer;

    const blob = new Blob(['\ufeff', sourceHTML], {
      type: 'application/msword'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'patent_document.doc';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div
        id="word-content"
        style={{
          fontFamily: 'Times New Roman',
          padding: 20,
          background: '#fff',
          color: '#000',
          maxWidth: 800,
          margin: '20px auto',
          height: "auto"
        }}
      >
        <h2 style={{ textAlign: 'center' }}>FORM 2</h2>
        <p style={{ textAlign: 'center' }}>
          <strong>THE PATENT ACT 1970</strong>
          <br />&<br />
          <strong>The Patents Rules, 2003</strong>
          <br />
          <u>COMPLETE SPECIFICATION</u>
        </p>

        <ReactMarkdown>{every}</ReactMarkdown>
      </div>

      <div style={{ textAlign: 'center' }}>
        <button onClick={handleDownload} className="button">
          Download Patent Word
        </button>
      </div>
    </>
  );
};

export default PatentWordGenerator;
